"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var GameSetsListCtl = /** @class */ (function (_super) {
    __extends(GameSetsListCtl, _super);
    function GameSetsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_tag = UIUtils_1.UIUtils.IProp2Str(function (o) { o.tag; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this.dk_gws_gameprovider_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gws_gameprovider_id; });
        _this.dk_gws_gameprovider_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gws_gameprovider_title; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_css_inactive_classname = UIUtils_1.UIUtils.IProp2Str(function (o) { o.css_inactive_classname; });
        _this.dk_css_active_classname = UIUtils_1.UIUtils.IProp2Str(function (o) { o.css_active_classname; });
        _this.dk_is_in_category = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_in_category; });
        _this.dk_is_in_menu = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_in_menu; });
        _this.dk_is_in_main_mobile_menu = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_in_main_mobile_menu; });
        _this.dk_init_gm_cnt_in_category = UIUtils_1.UIUtils.IProp2Str(function (o) { o.init_gm_cnt_in_category; });
        _this.dk_init_gm_cnt_in_menu = UIUtils_1.UIUtils.IProp2Str(function (o) { o.init_gm_cnt_in_menu; });
        _this.dk_sort_order_category = UIUtils_1.UIUtils.IProp2Str(function (o) { o.sort_order_category; });
        _this.dk_sort_order_menu = UIUtils_1.UIUtils.IProp2Str(function (o) { o.sort_order_menu; });
        _this.dk_games_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.games_count; });
        _this.dk_langs_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.langs_count; });
        _this.dk_cms_gameset_category_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.cms_gameset_category_type_code; });
        _this.dk_cms_gameset_category_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.cms_gameset_category_type_title; });
        _this.dk_gameprovider_value = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gameprovider_value; });
        _this.dk_fsconfig_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.fsconfig_count; });
        _this._errDialog = errDialog;
        return _this;
    }
    GameSetsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    GameSetsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "gameset with id [" + id + "] not found !";
    };
    GameSetsListCtl.prototype.LoadData = function (AllGwsGameProviders, order, GwsGameProviderIdList, onDone) {
        var _this = this;
        var sortOrder = 0;
        if (order === "byKey") {
            sortOrder = 0;
        }
        if (order === "byCategory") {
            sortOrder = 1;
        }
        if (order === "byMenu") {
            sortOrder = 2;
        }
        webAApi_1.ListCmsGameSetsByGameProviderIdGet.exec({
            all_game_providers: AllGwsGameProviders,
            gws_game_provider_id_list: GwsGameProviderIdList,
            sort_order: sortOrder
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    gws_gameprovider_id: resp.list[i].gws_gameprovider_id,
                    gws_gameprovider_title: resp.list[i].gws_gameprovider_title,
                    title: resp.list[i].title,
                    tag: resp.list[i].tag,
                    description: resp.list[i].description,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    is_locked: resp.list[i].is_locked,
                    sort_order_category: resp.list[i].sort_order_category,
                    sort_order_menu: resp.list[i].sort_order_menu,
                    css_inactive_classname: resp.list[i].css_inactive_classname,
                    css_active_classname: resp.list[i].css_active_classname,
                    is_in_category: resp.list[i].is_in_category,
                    is_in_menu: resp.list[i].is_in_menu,
                    is_in_main_mobile_menu: resp.list[i].is_in_main_mobile_menu,
                    init_gm_cnt_in_menu: resp.list[i].init_gm_cnt_in_menu,
                    init_gm_cnt_in_category: resp.list[i].init_gm_cnt_in_category,
                    games_count: resp.list[i].games_count,
                    langs_count: resp.list[i].langs_count,
                    cms_gameset_category_type_code: resp.list[i].cms_gameset_category_type_code,
                    cms_gameset_category_type_title: resp.list[i].cms_gameset_category_type_title,
                    gameprovider_value: resp.list[i].gameprovider_value,
                    fsconfig_count: resp.list[i].fsconfig_count
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    GameSetsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddCmsGameSet.exec({
            data: {
                title: data.title,
                description: data.description,
                tag: data.tag,
                gws_gameprovider_id: data.gws_gameprovider_id,
                is_locked: data.is_locked,
                sort_order_category: data.sort_order_category,
                sort_order_menu: data.sort_order_menu,
                css_inactive_classname: data.css_inactive_classname,
                css_active_classname: data.css_active_classname,
                is_in_category: data.is_in_category,
                is_in_menu: data.is_in_menu,
                is_in_main_mobile_menu: data.is_in_main_mobile_menu,
                init_gm_cnt_in_category: data.init_gm_cnt_in_category,
                init_gm_cnt_in_menu: data.init_gm_cnt_in_menu,
                cms_gameset_category_type_code: data.cms_gameset_category_type_code,
                gameprovider_value: data.gameprovider_value
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed2: moment(resp.date_changed_uts_ms).utc(false),
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                title: data.title,
                description: data.description,
                tag: data.tag,
                gws_gameprovider_id: data.gws_gameprovider_id,
                gws_gameprovider_title: resp.gameprovider_title,
                is_locked: data.is_locked,
                sort_order_category: data.sort_order_category,
                sort_order_menu: data.sort_order_menu,
                css_inactive_classname: data.css_inactive_classname,
                css_active_classname: data.css_active_classname,
                is_in_category: data.is_in_category,
                is_in_menu: data.is_in_menu,
                is_in_main_mobile_menu: data.is_in_main_mobile_menu,
                init_gm_cnt_in_category: data.init_gm_cnt_in_category,
                init_gm_cnt_in_menu: data.init_gm_cnt_in_menu,
                games_count: 0,
                langs_count: 0,
                cms_gameset_category_type_code: data.cms_gameset_category_type_code,
                cms_gameset_category_type_title: resp.cms_gameset_category_type_title,
                gameprovider_value: data.gameprovider_value,
                fsconfig_count: 0
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    GameSetsListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditCmsGameSet.exec({
                data: {
                    gameset_id: data.key,
                    title: data.title,
                    description: data.description,
                    tag: data.tag,
                    is_locked: data.is_locked,
                    sort_order_category: data.sort_order_category,
                    sort_order_menu: data.sort_order_menu,
                    css_inactive_classname: data.css_inactive_classname,
                    css_active_classname: data.css_active_classname,
                    is_in_category: data.is_in_category,
                    is_in_menu: data.is_in_menu,
                    is_in_main_mobile_menu: data.is_in_main_mobile_menu,
                    init_gm_cnt_in_category: data.init_gm_cnt_in_category,
                    init_gm_cnt_in_menu: data.init_gm_cnt_in_menu,
                    cms_gameset_category_type_code: data.cms_gameset_category_type_code,
                    gameprovider_value: data.gameprovider_value
                }
            }, function (resp) {
                _tmp.title = data.title;
                _tmp.description = data.description;
                _tmp.tag = data.tag;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.is_locked = data.is_locked;
                _tmp.sort_order_category = data.sort_order_category;
                _tmp.sort_order_menu = data.sort_order_menu;
                _tmp.css_inactive_classname = data.css_inactive_classname;
                _tmp.css_active_classname = data.css_active_classname;
                _tmp.is_in_category = data.is_in_category;
                _tmp.is_in_menu = data.is_in_menu;
                _tmp.is_in_main_mobile_menu = data.is_in_main_mobile_menu;
                _tmp.init_gm_cnt_in_menu = data.init_gm_cnt_in_category;
                _tmp.init_gm_cnt_in_menu = data.init_gm_cnt_in_menu;
                _tmp.cms_gameset_category_type_code = data.cms_gameset_category_type_code;
                _tmp.cms_gameset_category_type_title = resp.cms_gameset_category_type_title;
                _tmp.gameprovider_value = data.gameprovider_value;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GameSetsListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    GameSetsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteCmsGameSet.exec({
                data: {
                    gameset_id: key
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GameSetsListCtl.prototype.SetIsLocked = function (key, IsLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetCmsGameSetIsLocked.exec({
                data: {
                    gameset_id: key,
                    is_locked: IsLocked
                }
            }, function (resp) {
                _tmp.is_locked = IsLocked;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GameSetsListCtl.prototype.doSetSortOrderCategory = function (key, sortOrder, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetCmsGameSetSortOrderCategory.exec({
                data: {
                    cms_gameprovider_gameset_id: key,
                    sort_order_category: sortOrder
                }
            }, function (resp) {
                _tmp.sort_order_category = sortOrder;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GameSetsListCtl.prototype.doSetSortOrderMenu = function (key, sortOrder, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetCmsGameSetSortOrderMenu.exec({
                data: {
                    cms_gameprovider_gameset_id: key,
                    sort_order_menu: sortOrder
                }
            }, function (resp) {
                _tmp.sort_order_menu = sortOrder;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GameSetsListCtl.prototype.doAddGameToAllGameSets = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddGameToAllCategory.exec({
            data: {
                gameprovider_game_id: data.gameprovider_game_id,
                is_table_game: data.is_table_game,
                is_add_to_top: data.is_add_to_top,
                offset_from_top_place_down: data.offset_from_top_place_down,
                app_currency_id: data.app_currency_id
            }
        }, function (resp) {
            _this.Update();
            if (onDone) {
                onDone(resp.game_title);
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return GameSetsListCtl;
}(BaseController_1.BaseController));
exports.GameSetsListCtl = GameSetsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_gamesets_list/ctl/GameSetsListCtl.ts
// module id = 868
// module chunks = 0